import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { keycloak } from "../utils/keycloak";
import { useMobxStores } from "../stores/stores";
import { observer } from "mobx-react";
import {
  Row,
  Col,
  Input,
  Empty,
  Tooltip,
  Select,
  Button,
  Skeleton,
  Avatar,
  Card,
  Grid,
  Modal,
} from "antd";
import { HeartFilled } from "@ant-design/icons";
import ItemPreview from "../components/marketplace/ItemPreview";
import CreateItemModal from "../components/marketplace/CreateItemModal";
import FilterOptions from "../components/marketplace/FilterOptions";
import ImageBackground from "../components/marketplace/ImageBackground";
import PlusIconWhite from "../assets/plus-icon-white.png";
import "./Marketplace.css";
// import { ReactComponent as TopLeftShape } from "../assets/Ellipse38.svg";
import { ReactComponent as TopRightRightShape } from "../assets/MarketPlaceTopRightRight.svg";
import { ReactComponent as TopRightLeftShape } from "../assets/MarketPlaceTopRightLeft.svg";

import { ReactComponent as MarketPlaceBottomLeft } from "../assets/horns.svg";
import { ReactComponent as MarketPlaceBottomRight } from "../assets/MarketPlaceBottomRight.svg";
import { SearchOutlined } from "@ant-design/icons";
const { Option } = Select;
const { Meta } = Card;

const sort_options = [
  { name: "Oldest", value: "created" },
  { name: "Popularity ascending", value: "views" },
  { name: "Newest", value: "-created" },
  { name: "Popularity descending", value: "-views" },
];

const { useBreakpoint } = Grid;
const Marketplace = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.sm;
  const { marketplaceStore } = useMobxStores();
  const trackingRef = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (keycloak.authenticated && searchParams.get("openCreate") === "true") {
      marketplaceStore.setIsMarketplaceCreateModalOpen(true);
      navigate("/marketplace", { replace: true });
    }
  }, []);

  useEffect(() => {
    if (marketplaceStore.activeFilter) {
      setSearchValue("");
    }
  }, [marketplaceStore.activeFilter]);

  useEffect(() => {
    if (!marketplaceStore.activeFilter) {
      marketplaceStore.GetMarketplaceItems();
    }
    marketplaceStore.setMarketplaceItem(null);
    marketplaceStore.setNFT(null);

    marketplaceStore.GetPolygonNetworkIcon();
    marketplaceStore.GetEtheriumNetworkIcon();
  }, [marketplaceStore]);

  const handleSearch = (e) => {
    if (marketplaceStore.activeFilter) marketplaceStore.setActiveFilter("");
    if (e.target.value !== "") {
      marketplaceStore.GetMarketplaceItemsByTypeOrName({
        order: "name",
        value: e.target.value,
      });
    } else {
      marketplaceStore.GetMarketplaceItems();
    }
  };

  const useDebouncedSearch = (callback, delay = 300) => {
    let timer;

    return (...args) => {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => callback(...args), delay);
    };
  };

  const debouncedSearch = useDebouncedSearch(handleSearch);

  return (
    <>
      {isMobile ? (
        <div>
          <CreateItemModal />
          <div
            style={{ display: "flex", flexDirection: "column", gap: "48px" }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <Row
                style={{
                  marginTop: "24px",
                  paddingTop: "2%",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                <Input
                  value={searchValue}
                  style={{ width: "40%", fontSize: "14px", height: "28px" }}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    debouncedSearch(e);
                  }}
                  suffix={<SearchOutlined style={{ color: "#5F5F6BAB" }} />}
                  // placeholder="Search by name or #tag"
                />
                <Select
                  placeholder={"Sort by"}
                  style={{ width: "auto", fontSize: "14px", height: "28px" }}
                  popupMatchSelectWidth={false}
                >
                  {sort_options.map((item, index) => {
                    return (
                      <Option key={index} value={item.name}>
                        <Button
                          type="text"
                          onClick={() =>
                            marketplaceStore.GetMarketplaceItems(item.value)
                          }
                        >
                          {item.name}
                        </Button>
                      </Option>
                    );
                  })}
                </Select>
              </Row>
              <Row justify={"center"} align={"middle"}>
                <Col
                  span={24}
                  style={{
                    textAlign: "center",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FilterOptions />
                </Col>
              </Row>
            </div>
            <Row
              justify={
                marketplaceStore.marketplaceItems.length === 0
                  ? "center"
                  : "start"
              }
              align={"middle"}
              style={{ width: "90%", margin: "auto" }}
            >
              {marketplaceStore.marketplaceItems.map((item, index) => {
                return (
                  <Col
                    justify={"center"}
                    align={"middle"}
                    key={index}
                    xl={6}
                    xxl={4}
                    md={10}
                    sm={14}
                    xs={24}
                  >
                    {index === 0 && marketplaceStore.loadingLastItem ? (
                      <Card
                        className="loading-item-card"
                        key={item.id}
                        extra={
                          <div style={{ marginRight: "8px" }}>
                            <HeartFilled
                              style={{ fontSize: "24px", color: "whitesmoke" }}
                            />
                          </div>
                        }
                      >
                        <Skeleton loading avatar active>
                          <Meta
                            avatar={
                              <Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel&key=2" />
                            }
                            title="Card title"
                            description="This is the description"
                          />
                        </Skeleton>
                      </Card>
                    ) : (
                      <ItemPreview item={item} />
                    )}
                  </Col>
                );
              })}
              {marketplaceStore.marketplaceItems.length === 0 && (
                <Empty description="No items found" />
              )}
            </Row>
          </div>
          <Tooltip title="Add an item!">
            <div
              className="marketplace-create-item-button"
              onClick={() => {
                if (keycloak.authenticated) {
                  marketplaceStore.setIsMarketplaceCreateModalOpen(true);
                } else {
                  Modal.confirm({
                    title: "Sign in required",
                    content:
                      "You are not allowed to perform this action. You need to sign in first.",
                    okText: "Sign in",
                    cancelText: "Cancel",
                    onOk: () =>
                      keycloak.login({
                        redirectUri:
                          window.location.origin +
                          "/marketplace?openCreate=true",
                      }),
                  });
                }
              }}
            >
              <img
                src={PlusIconWhite}
                className="plusButtonSize"
                alt="plus icon"
              />
            </div>
          </Tooltip>
        </div>
      ) : (
        <div
          style={{ paddingBottom: "100px", position: "relative" }}
          ref={trackingRef}
        >
          <div
            style={{
              // backgroundColor: " #000080",
              position: "absolute",
              inset: 0, // = top:0, right:0, bottom:0, left:0
              zIndex: -1, // lower z-index
            }}
          >
            {/* <img
            src={BackgroundImage}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          /> */}
            <TopRightRightShape
              style={{
                position: "fixed",
                top: "7vh",
                right: "0vw",
                width: "10vw", // scales with viewport width
                height: "auto", // keep aspect ratio
                pointerEvents: "none", // so it doesn’t block clicks
              }}
            />
            <TopRightLeftShape
              style={{
                position: "fixed",
                top: "35vh",
                right: "13vw",
                width: "10vw", // scales with viewport width
                height: "auto", // keep aspect ratio
                pointerEvents: "none", // so it doesn’t block clicks
              }}
            />
            <TopRightLeftShape
              style={{
                position: "fixed",
                top: "48vh",
                right: "24vw",
                width: "20vw", // scales with viewport width
                height: "auto", // keep aspect ratio
                pointerEvents: "none", // so it doesn’t block clicks
              }}
            />
            <MarketPlaceBottomRight
              style={{
                position: "fixed",
                top: "18vh",
                right: "42vw",
                width: "13vw", // scales with viewport width
                height: "auto", // keep aspect ratio
                pointerEvents: "none", // so it doesn’t block clicks
              }}
            />
            {/* <TopLeftShape
          style={{
            position: "fixed",
            top: "10vh",
            left: "-50px",
            width: "34vw", // scales with viewport width
            height: "auto", // keep aspect ratio
            pointerEvents: "none", // so it doesn’t block clicks
          }}
        />   */}
            <MarketPlaceBottomLeft
              style={{
                position: "fixed",
                left: "0vw",
                bottom: "30px",
                width: "30vw", // slightly bigger
                height: "auto",
                pointerEvents: "none",
              }}
            />
            <MarketPlaceBottomRight
              style={{
                position: "fixed",
                right: "15vw",
                bottom: "2vw",
                width: "10vw", // slightly bigger
                height: "auto",
                pointerEvents: "none",
              }}
            />
            <MarketPlaceBottomRight
              style={{
                position: "fixed",
                left: "-4vw",
                top: "12vh",
                width: "10vw", // slightly bigger
                height: "auto",
                pointerEvents: "none",
              }}
            />
          </div>
          {/* <ImageBackground /> */}
          <CreateItemModal />
          <div
            style={{ display: "flex", flexDirection: "column", gap: "48px" }}
          >
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <Row
                style={{
                  paddingTop: "2%",
                  gap: "16px",
                  justifyContent: "center",
                }}
              >
                <Input
                  value={searchValue}
                  style={{ width: "40%" }}
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    debouncedSearch(e);
                  }}
                  placeholder="Search by name or #tag"
                />
                <Select
                  placeholder={"Sort by"}
                  style={{ width: "auto" }}
                  popupMatchSelectWidth={false}
                >
                  {sort_options.map((item, index) => {
                    return (
                      <Option key={index} value={item.name}>
                        <Button
                          type="text"
                          onClick={() =>
                            marketplaceStore.GetMarketplaceItems(item.value)
                          }
                        >
                          {item.name}
                        </Button>
                      </Option>
                    );
                  })}
                </Select>
              </Row>
              <Row justify={"center"} align={"middle"}>
                <Col
                  span={24}
                  style={{
                    textAlign: "center",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <FilterOptions />
                </Col>
              </Row>
            </div>
            <Row
              justify={
                marketplaceStore.marketplaceItems.length === 0
                  ? "center"
                  : "start"
              }
              align={"middle"}
              style={{ width: "90%", margin: "auto" }}
            >
              {marketplaceStore.marketplaceItems.map((item, index) => {
                return (
                  <Col
                    justify={"center"}
                    align={"middle"}
                    key={index}
                    xl={6}
                    xxl={4}
                    md={10}
                    sm={14}
                    xs={24}
                  >
                    {index === 0 && marketplaceStore.loadingLastItem ? (
                      <Card
                        className="loading-item-card"
                        key={item.id}
                        extra={
                          <div style={{ marginRight: "8px" }}>
                            <HeartFilled
                              style={{ fontSize: "24px", color: "whitesmoke" }}
                            />
                          </div>
                        }
                      >
                        <Skeleton loading avatar active>
                          <Meta
                            avatar={
                              <Avatar src="https://xsgames.co/randomusers/avatar.php?g=pixel&key=2" />
                            }
                            title="Card title"
                            description="This is the description"
                          />
                        </Skeleton>
                      </Card>
                    ) : (
                      <ItemPreview item={item} />
                    )}
                  </Col>
                );
              })}
              {marketplaceStore.marketplaceItems.length === 0 && (
                <Empty description="No items found" />
              )}
            </Row>
          </div>
          <Tooltip title="Add an item!">
            <div
              className="marketplace-create-item-button"
              onClick={() => {
                if (keycloak.authenticated) {
                  marketplaceStore.setIsMarketplaceCreateModalOpen(true);
                } else {
                  Modal.confirm({
                    title: "Sign in required",
                    content:
                      "You are not allowed to perform this action. You need to sign in first.",
                    okText: "Sign in",
                    cancelText: "Cancel",
                    onOk: () =>
                      keycloak.login({
                        redirectUri:
                          window.location.origin +
                          "/marketplace?openCreate=true",
                      }),
                  });
                }
              }}
            >
              <img
                src={PlusIconWhite}
                className="plusButtonSize"
                alt="plus icon"
              />
            </div>
          </Tooltip>
        </div>
      )}
    </>
  );
};
export default observer(Marketplace);
